import { SVGProps } from 'react'

function ShowPassword(props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) {
  return (
    <svg width={22} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M10.9996 4.37588C7.64045 4.31922 4.16628 6.66672 1.98211 9.07088C1.50726 9.59805 1.50726 10.3987 1.98211 10.9259C4.11878 13.2792 7.58295 15.6809 10.9996 15.6234C14.4163 15.6809 17.8813 13.2792 20.0196 10.9259C20.4945 10.3987 20.4945 9.59805 20.0196 9.07088C17.8329 6.66672 14.3588 4.31922 10.9996 4.37588Z"
        stroke="#232B43"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M14.125 10.0001C14.1245 11.7259 12.7252 13.1246 10.9994 13.1243C9.27366 13.124 7.87485 11.7248 7.875 9.99899C7.87515 8.27321 9.27422 6.87427 11 6.87427C11.829 6.87405 12.6241 7.20333 13.2102 7.78961C13.7964 8.37589 14.1254 9.17109 14.125 10.0001V10.0001Z"
        stroke="#232B43"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ShowPassword.defaultProps = { role: 'graphics-document' }

export default ShowPassword
